import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchEvents = (id: string) => {
  return useQuery({
    queryKey: ['referralEvents', id],
    queryFn: () => api.referral.fetchEvents(id),
    enabled: false, // Запрос выполняется только по требованию
  })
}
